export const GATEKEEPER_GET = 'GATEKEEPER_GET'
export const GATEKEEPER_LOAD = 'GATEKEEPER_LOAD'
export const GATEKEEPER_SUCCESS = 'GATEKEEPER_SUCCESS'
export const GATEKEEPER_RESULT = 'GATEKEEPER_RESULT'
export const GATEKEEPER_ERROR = 'GATEKEEPER_ERROR'
export const GATEKEEPER_CLEAR = 'GATEKEEPER_CLEAR'
